import { Component } from "react";
import stars from "./stars.js";
import Card from "@/components/card.js";
import compass from "@/images/boussole.svg"
import LinkButton from "@/components/linkButton.js";
import Modal from "@/components/modal.js";

class DiscoverCourse extends Component {
  constructor(props) {
    super(props);
    this.state = { showCard: false }
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(event) {
    event.stopPropagation();
    this.setState({ showCard: !this.state.showCard });
  }

  render() {
    return (
      <div className="flex justify-center">
        <svg xmlns="http://www.w3.org/2000/svg" width="95" height="95" viewBox="0 0 95 95" className="fill-current stroke-current text-gray-light hover:text-orange transform hover:rotate-90 transition-transform duration-300 order-1 cursor-pointer" onClick={(event) => this.handleClick(event)}>
          {stars[this.props.index].content}
        </svg>
        {this.state.showCard &&
          <Modal onClick={(event) => this.handleClick(event)}>
              <Card
                width="1"
                height="1"
                justify="center"
                background="khaki-light"
                textColor="gray-darkest"
                border="khaki-default"
                borderRadius="md"
                borderSize="4"
                image={`star_${this.props.index}`}
                imagePosition="left"
              >
                
                <div className="flex w-full">
                  <div className="sm:w-1/3"></div>
                  <div className="sm:w-2/3 w-full flex flex-col items-center gap-4">
                    <p className="md:text-khaki-default text-gray-darkest uppercase font-t-semibold">
                      {this.props.course.Domaine_Professionnel.map((field) => 
                        <>{field}<br/></>
                      )}
                      </p>
                    <p className="underline text-xs">{this.props.course.Type_de_diplome}</p>
                    <h4 className="font-t-semibold text-xl">
                      {this.props.course.Domaine_du_MESRI_1}<br />
                      {this.props.course.Parcours_Specialites_ED}
                    </h4>
                    <p className="uppercase text-gray-lighter font-t-semibold">{this.props.course.Domaine_du_MESRI}</p>
                    <div className="flex w-full items-center">
                      <div className="border-b border-gray-lighter grow w-full"></div>
                      <img src={compass} alt="logo boussole" className="mt-2" />
                      <div className="border-b border-gray-lighter grow w-full"></div>
                    </div>
                    {this.props.course.Lien_FF__Site_dedie && 
                      <LinkButton
                        label="En savoir +"
                        padding="2"
                        classes="text-xs"
                        href={this.props.course.Lien_FF__Site_dedie}
                        target="blank"
                      />
                    }
                  </div>
                </div>
              </Card>
          </Modal>
        }
      </div>

    );
  }
}

export default DiscoverCourse;